<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-08 17:57:55
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-08 19:35:48
 * @Description: 审核信息列表
 -->
<template>
  <div class="list-wrapper">
    <router-link to="fn-2016" class="link-item">2016年财务报告</router-link>
    <router-link to="fn-2017" class="link-item">2017年财务报告</router-link>
    <router-link to="fn-2018" class="link-item">2018年财务报告</router-link>
    <router-link to="sp-2018" class="link-item">2018年专项审计报告</router-link>
    <router-link to="im-2019" class="link-item">2019年重点环节专项审计报告</router-link>
  </div>
</template>
<script>
export default {
  name: 'check-info-list'
};
</script>
<style lang="less" scoped>
.list-wrapper {
  .link-item {
    display: flex;
    border-bottom: 1px dashed #ddd;
    justify-content: space-between;
    align-items: center;
    height: 50px;
  }
}
</style>
